export enum Civility {
  Monsieur = 1,
  Madame = 2,
  Autre = 3,
}
